import { render, staticRenderFns } from "./ChatPrivateSide.vue?vue&type=template&id=db317bbe&scoped=true"
import script from "./ChatPrivateSide.vue?vue&type=script&lang=js"
export * from "./ChatPrivateSide.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateSide.vue?vue&type=style&index=0&id=db317bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db317bbe",
  null
  
)

export default component.exports